(function (ng) {
    /// <summary>
    /// Service to fetch Evo Trip details
    /// </summary>
    ng.module('evo.Trip.Services').factory('tripInformationService', ['$http', 'EVOTRIP_SERVICE_BASE', function ($http, EVOTRIP_SERVICE_BASE) {
        function getValueOrDefault(object, key, defaultValue) {
            return object != null && object[key] != null ? object[key] : defaultValue;
        }

        return {
            /// <summary>
            /// Get information for the specified tripId
            /// </summary>
            /// <param name="tripId">the trip to fetch information for</param>
            get: function (tripId) {
                var $tripInfo = $('[data-trip-id=' + tripId + ']'),
                    deposit = parseFloat($tripInfo.data('dp'));

                if (isNaN(deposit) || deposit < 0)
                    deposit = 0.00;
                // Get trip inventory for the specified sku and return trip information
                return $http.get(EVOTRIP_SERVICE_BASE + $tripInfo.data('sku')).then(function (result) {
                    return {
                        BrandName: getValueOrDefault(result.data, 'BrandName', ''),
                        CoreTaxonomyNodeId: getValueOrDefault(result.data, 'CoreTaxonomyNodeId', 0),
                        Date: getValueOrDefault(result.data, 'Date', $tripInfo.data('trip-date')),
                        DepositAmount: getValueOrDefault(result.data, 'DepositAmount', deposit),
                        Inventory: getValueOrDefault(result.data, 'Inventory', 0),
                        Unavailable: $tripInfo.data('trip-unavailable') === 'True',
                        ItemId: getValueOrDefault(result.data, 'ItemId', 0),
                        MSRP: getValueOrDefault(result.data, 'MSRP', 0),
                        Name: getValueOrDefault(result.data, 'Name', $tripInfo.data('trip-name')),
                        OriginalPrice: getValueOrDefault(result.data, 'OriginalPrice', 0),
                        Price: getValueOrDefault(result.data, 'Price', 0),
                        ProductId: getValueOrDefault(result.data, 'ProductId', 0),
                        RetailPrice: getValueOrDefault(result.data, 'RetailPrice', 0),
                        SKU: getValueOrDefault(result.data, 'SKU', $tripInfo.data('sku')),
                        DisplayAffirm: getValueOrDefault(result.data, 'DisplayAffirm', false)
                    };
                }, function (err) {
                    return {
                        BrandName: '',
                        CoreTaxonomyNodeId: 0,
                        Date: $tripInfo.data('trip-date'),
                        DepositAmount: deposit,
                        Inventory: 0,
                        Unavailable: $tripInfo.data('trip-unavailable') === 'True',
                        ItemId: 0,
                        MSRP: 0,
                        Name: $tripInfo.data('trip-name'),
                        OriginalPrice: 0,
                        Price: 0,
                        ProductId: 0,
                        RetailPrice: 0,
                        SKU: $tripInfo.data('sku'),
                        DisplayAffirm: false
                    };
                });
            }
        };
    }]);
})(angular);